import { Component, OnInit } from '@angular/core';
import { MedicoService } from './../../shared/servicio/medico/medico.service';
import Chart from 'chart.js';
import { AssociateSidebarService } from 'src/app/associate/services/associate-sidebar.service';

@Component({
  selector: 'app-estadistica',
  templateUrl: './estadistica.component.html',
  styleUrls: ['./estadistica.component.css']
})
export class EstadisticaComponent implements OnInit {
  statistics: any;
  isLoading = false;
  selectedMonth;
  selectedYear;
  medicId;
  selectedMonthYear: string = ''; // Formato: '2025-05'

  constructor(private medicService: MedicoService, private _sidebar: AssociateSidebarService) { }

  ngOnInit(): void {
    const now = new Date();
    this.selectedMonthYear = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

    // ✅ Extraer mes como string con formato "07"
    const [year, month] = this.selectedMonthYear.split('-');
    this.selectedMonth = month; // 📝 Mantener como string "07"
    this.selectedYear = +year;

    this.getUserInfo();
  }


  onMonthChange() {
    if (this.selectedMonthYear) {
      const [year, month] = this.selectedMonthYear.split('-');
      this.selectedMonth = month; // 📝 Mantener como string "07"
      this.selectedYear = +year;
      this.loadStatistics();
    }
  }

  getUserInfo() {
    this._sidebar.getUserInfo().toPromise().then((data: any) => {
      console.log(data);
      this.medicId = data.idmedic;
      console.log(this.medicId);
      this.isLoading = false;
      this.loadStatistics();
    });
  }


  loadStatistics(): void {
    this.isLoading = true;
    // 📝 selectedMonth ya es string "07", selectedYear es number
    this.medicService.getStatistics(this.medicId, this.selectedMonth, this.selectedYear).subscribe({
      next: (res: any) => {
        this.statistics = res;
        this.isLoading = false;
        this.renderCharts();
      },
      error: (err) => {
        console.error('Error loading statistics', err);
        this.isLoading = false;
      }
    });
  }

  renderCharts(): void {
    if (!this.statistics) return;

    const pieCtx: any = document.getElementById('pieChart');
    const barCtx: any = document.getElementById('barChart');

    // 🎯 Paleta oficial para Gráfico de Dona (Distribución de Puntos)
    const pieColors = [
      'rgba(54, 162, 235, 0.8)',   // Puntos Disponibles - Azul brillante
      'rgba(255, 99, 132, 0.8)',   // Puntos Redimidos - Rojo coral
      'rgba(255, 206, 86, 0.8)',   // Puntos a expirar - Amarillo dorado
      '#d1d5db'                    // Puntos expirados - Gris 300 como neutro
    ];

    // 🎯 Paleta oficial para Gráfico de Barras (Referencias)
    const barColors = [
      '#16a34a', // Pacientes efectivos - Verde 600
      '#9333ea', // Referencias este mes - Morado 600
      '#2563eb'  // Total referencias - Azul 600
    ];

    // 📊 Pie Chart - Distribución de Puntos
    new Chart(pieCtx, {
      type: 'pie',
      data: {
        labels: ['Disponibles', 'Redimidos', 'A expirar', 'Expirados'],
        datasets: [{
          data: [
            this.statistics.available_points,
            this.statistics.redeemed_points,
            this.statistics.points_to_expire,
            this.statistics.expired_points
          ],
          backgroundColor: pieColors
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
          tooltip: {
            callbacks: {
              label: (context: any) => `${context.label}: ${context.formattedValue}`
            }
          }
        }
      }
    });

    // 📊 Bar Chart - Referencias
    new Chart(barCtx, {
      type: 'bar',
      data: {
        labels: ['Pacientes efectivos', 'Referencias este mes', 'Total referencias'],
        datasets: [{
          label: 'Cantidad',
          data: [
            this.statistics.effective_patients,
            this.statistics.referrals_this_month,
            this.statistics.total_referrals
          ],
          backgroundColor: barColors,
          borderColor: ['#15803d', '#7c3aed', '#1d4ed8'], // versión más oscura para borde
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              color: '#374151' // Texto en gris-600
            },
            grid: {
              color: '#e5e7eb' // Líneas grises suaves
            }
          },
          x: {
            ticks: {
              color: '#374151'
            },
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context: any) => `Cantidad: ${context.formattedValue}`
            }
          }
        }
      }
    });
  }

}
